<template>
    <div class="flex wip">
        <slot></slot>
    </div>
</template>

<script lang="ts" setup>
</script>